import { FC, MutableRefObject, Suspense } from 'react';
import { PreloadedQuery } from 'react-relay';
import ExitSlipModalBodyNoDataYet from './ExitSlipModalBodyNoDataYet';
import ExitSlipModalAssignBodyQuery from './ExitSlipModalAssignBodyQuery';
import ExitSlipModalEditBodyQuery from './ExitSlipModalEditBodyQuery';
import { ExitSlipCurriculumLessonsQuery } from '../../graphQLOperations/__generated__/ExitSlipCurriculumLessonsQuery.graphql';
import { ExitSlipModalType } from '../../redux/reducers/exitSlipModalSlice';
import { LessonDate } from './ExitSlipModalContainer';
import { ThreeDotLoader } from '../Fallback/ThreeDotsLoader';
import { Toast } from 'primereact/toast';
import { ExitSlipClassExitSlipDueOnByClassesQuery } from '../../graphQLOperations/__generated__/ExitSlipClassExitSlipDueOnByClassesQuery.graphql';

interface Props {
  queryReference: PreloadedQuery<ExitSlipCurriculumLessonsQuery, Record<string, unknown>>;
  queryDisabledDatesReference: PreloadedQuery<ExitSlipClassExitSlipDueOnByClassesQuery, Record<string, unknown>>;
  setNoDataYet: (d: boolean) => void;
  noDataYet: boolean;
  lessonDates: LessonDate[];
  setLessonDates: (a: LessonDate[]) => void;
  modalType: ExitSlipModalType | undefined;
  setSaveButtonDisabled: (s: boolean) => void;
  toast: MutableRefObject<Toast | null>;
  setApplyRefetchSnapshot: (s: boolean) => void;
  refreshPanel: () => void;
}

const ExitSlipModalBody: FC<Props> = ({
  queryReference,
  queryDisabledDatesReference,
  setNoDataYet,
  noDataYet,
  lessonDates,
  setLessonDates,
  modalType,
  setSaveButtonDisabled,
  toast,
  setApplyRefetchSnapshot,
  refreshPanel,
}) => {
  return (
    <>
      {!queryReference || noDataYet ? (
        <ExitSlipModalBodyNoDataYet />
      ) : modalType === ExitSlipModalType.EDIT ? (
        <Suspense fallback={<ThreeDotLoader />}>
          <ExitSlipModalEditBodyQuery
            queryReference={queryReference}
            queryDisabledDatesReference={queryDisabledDatesReference}
            setNoDataYet={setNoDataYet}
            lessonDates={lessonDates}
            setLessonDates={setLessonDates}
            setSaveButtonDisabled={setSaveButtonDisabled}
            toast={toast}
            setApplyRefetchSnapshot={setApplyRefetchSnapshot}
            refreshPanel={refreshPanel}
          />
        </Suspense>
      ) : (
        <Suspense fallback={<ThreeDotLoader />}>
          <ExitSlipModalAssignBodyQuery
            queryReference={queryReference}
            queryDisabledDatesReference={queryDisabledDatesReference}
            setNoDataYet={setNoDataYet}
            lessonDates={lessonDates}
            setLessonDates={setLessonDates}
            setSaveButtonDisabled={setSaveButtonDisabled}
          />
        </Suspense>
      )}
    </>
  );
};

export default ExitSlipModalBody;
